/**
 * @file index.ts
 * @description Основной файл конфигурации маршрутизации приложения системы управления задачами.
 * Определяет структуру всех доступных маршрутов с соответствующими компонентами и макетами.
 * Конфигурирует публичные и приватные маршруты, включая страницы каталогов, очередей, отчетов,
 * графиков, аутентификации и обработки ошибок. Использует иерархическую структуру маршрутов
 * с поддержкой вложенных путей и динамической генерации через renderRoutes.
 * Интегрируется с различными макетами (Main, Login) для разных типов страниц.
 * @author AI Assistant
 * @created 2025-09-04
 * @updated 2025-09-04
 * @dependencies [@components/layouts, ./generate-routes.tsx, @pages/login, @pages/default, @features/catalog, @features/queue, @features/report, @features/chart, @pages/catalogs, @pages/queues, @pages/reports, @pages/charts]
 * @related-files [./generate-routes.tsx, @components/layouts/Main.tsx, @components/layouts/Login.tsx]
 */

// Layouts
import { Main as MainLayout } from '@components/layouts';
import { Login as LoginLayout } from '@components/layouts';
import { renderRoutes } from './generate-routes.tsx';

// Pages
import { Login } from '@pages/login';
import { Default } from '@pages/default';
import { Catalog } from '@features/catalog';
import { Queue } from '@features/queue';
import { Report } from '@features/report';
import { Chart } from '@features/chart';
import { default as catalogs } from '@pages/catalogs/index.ts';
import { default as queues } from '@pages/queues/index.ts';
import { default as reports } from '@pages/reports/index.ts';
import { default as charts } from '@pages/charts/index.js';

export const routes = [
    {
        layout: MainLayout,
        component: Catalog,
        routes: catalogs
    },
    {
        layout: MainLayout,
        component: Queue,
        routes: queues
    },
    {
        layout: MainLayout,
        component: Report,
        routes: reports
    },
    {
        layout: MainLayout,
        component: Chart,
        routes: charts
    },
    {
        layout: LoginLayout,
        path: '/login',
        component: Login,
        isPublic: true,
        routes: [
            {
                name: 'login',
                title: 'Login page',
                path: '',
                component: Login
            }
        ]
    },
    {
        layout: MainLayout,
        component: Default,
        path: '/',
        routes: [
            {
                title: 'ParentPage',
                path: '*'
            }
        ]
    }
];

export const Routes = renderRoutes(routes);
